<template>
  <div>
    <page-title
      title="Your work preferences"
      description="What kind of working style suits you best? Please select your preferred project type, company and work setting. This helps us better match you with the most relevant employment opportunities."
    />

    <div class="mb-6">
      <label for="" class="block text-md font-albert text-brand-black/70 mb-2">Job Readiness</label>
      <div class="flex flex-wrap gap-x-6">
        <div class="flex items-center gap-x-2 flex-nowrap mb-2 md:mb-0" v-for="(item, i) in enums?.candidate_availability_statuses" :key="i">
          <input type="radio" name="availability_status" :value="item.key" :id="item.value" v-model="details.availability_status" />
          <label :for="item.value">{{ item.value }}</label>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
      <div>
        <label class="block text-md font-albert text-brand-black/70 mb-2">Industry type</label>
        <v-select
          multiple
          v-model="details.company_categories"
          :disabled="details.company_categories.length >= 3"
          :options="categories"
          :reduce="(category) => category.value"
          label="value"
          placeholder="Select up to 3"
          taggable
        >
        </v-select>
      </div>

      <div>
        <label class="block text-md font-albert text-brand-black/70 mb-2">Company culture</label>
        <v-select multiple v-model="details.next_role_perks" :options="culture_options" placeholder="Select up to 3" taggable> </v-select>
      </div>

      <div>
        <label class="block text-md font-albert text-brand-black/70 mb-2">Role type</label>
        <v-select
          multiple
          v-model="details.job_types"
          :reduce="(item) => item.key"
          label="value"
          :options="enums?.job_types"
          placeholder="Select up to 2"
          taggable
        >
        </v-select>
      </div>

      <div>
        <label class="block text-md font-albert text-brand-black/70 mb-2">Job category</label>
        <v-select v-model="details.professional_title" label="value" :options="jobCategories" :reduce="(item) => item.key" placeholder="Select">
        </v-select>
      </div>

      <div>
        <label class="block text-md font-albert text-brand-black/70 mb-2">Work location</label>
        <v-select multiple v-model="details.work_type" :options="locations" placeholder="Select up to 3" taggable> </v-select>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageTitle from './PageTitle.vue';
import { ref } from 'vue';

const props = defineProps({
  details: {
    type: Object,
  },
  countries: {
    type: Array,
  },
  timezones: {
    type: Array,
  },
  enums: {
    type: Array,
    default: [],
  },
  categories: {
    type: Array,
    default: [],
  },
  jobCategories: {
    type: Array,
    default: [],
  },
});

const culture_options = ref([
  'More Money',
  'Flexibility and Wellbeing',
  'Working with great people',
  'Innovative product',
  'Remote Work',
  'Great tech and tools',
  'Recognition and reward',
  'Development and progression',
  'Diversity and Inclusion',
]);

const locations = ref(['Remote', 'Hybrid', 'Full in-office']);
</script>
